<template>
  <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';

export default {
  name: 'CShanxianBanner',
  components: {
    [button.name]: button,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'shanxian-banner-',
    };
  },
  computed: {
    computedStyle() {
      return Object.assign({}, {
        ...this.styles.base,
        backgroundSize: '100% 100%',
        backgroundImage: `url(${this.configurationData.backgroundImame})`,
      });
    },
  },
  async mounted() {
    console.log('configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$isInEditor) return;
      this.$refs.button.setClickHandler(this.btnClick, {
        forceApp: true,
        forceLogin: false,
      });
    },
    btnClick() {
      console.log('btnClick');
      this.bannerReport();
      this.$ast.openView({ url: this.configurationData.link });
    },
    bannerReport() { // 闪现banner上报
      this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '03', '35');
      const extendId = Number(this.configurationData.extendId);
      if (26 < extendId && extendId < 30) {
        this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '03', '30');
      } else if (30 < extendId && extendId < 34) {
        this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '03', '34');
      }
      this.$pluginSparkReport.report(
        this.pageInfo.canvasConfig.reportPv,
        this.configurationData.eventType,
        this.configurationData.extendId,
      );
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
